import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  defaultContainer: {
    paddingBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 93,
    [`@media(max-width: ${theme.breakpoints.md}px)`]: {
      paddingBottom: /* eslint-disable-line local-rules/use-theme-tokens */ 25,
    },
  },
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: theme.colors.gray2[0],
    gap: /* eslint-disable-line local-rules/use-theme-tokens */ '24px',
  },
  contestCardContainer: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column nowrap',
    width: '100%',
    height: '100%',
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '16px',
    backgroundColor: theme.colors.gray2[0],
    paddingTop: /* eslint-disable-line local-rules/use-theme-tokens */ '150px',
    gap: /* eslint-disable-line local-rules/use-theme-tokens */ '24px',

    '& > div': {
      maxWidth: '440px',
    },

    [`@media(max-width: ${theme.breakpoints.md}px)`]: {
      paddingTop: /* eslint-disable-line local-rules/use-theme-tokens */ '100px',
      paddingBottom: /* eslint-disable-line local-rules/use-theme-tokens */ '50px',
    },
  },
}));

export default useStyles;
